module.exports = __webpack_public_path__ + "static/media/BioscriptRethinkTommorow.8da3d8dd.svg";